// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import styled, { css } from 'styled-components';

export const BreadcrumbsWrapper = styled.div`
  display: flex;
  gap: 8px;
`;

export const Breadcrumb = styled.a<{
  isDark?: boolean;
}>(
  ({ theme, isDark }) => css`
    cursor: pointer;
    color: ${isDark ? theme.colors.white : theme.colors.base.lighter};

    :hover {
      color: ${
        isDark ? theme.colors.secondary.light : theme.colors.primary.main
      };
    }

    :active {
      color: ${
        isDark ? theme.colors.secondary.dark : theme.colors.primary.dark
      };
    }
  `,
);
